module.exports = __webpack_public_path__ + "media/de_de_s1_Dietmar.c8df5a26.mp3";